import { PaymentSchedule } from '@app/models/PaymentSchedule';
import { PaymentDue } from '@app/services/shared/PaymentDue.type';
import { todo } from '@app/util/todo';
import { FuturePayment } from '@app/models/FuturePayment';
import { PaymentMethod } from '@app/models/PaymentMethod';
import { Property } from '@app/models/Property';
import { PaymentApi } from '@app/services/apiServices/PaymentApi';
import { PaymentMethodApi } from '@app/services/apiServices/PaymentMethodApi';
import { PaymentScheduleApi } from '@app/services/apiServices/PaymentScheduleApi';
import { PropertyApi } from '@app/services/apiServices/PropertyApi';
import { NetworkErrorService } from '@app/services/NetworkError.service';
import { ErrorHandlerService } from '@app/services/ErrorHandler.service';
import { SpinnerService } from '@app/services/spinner.service';
import { PaymentEditStore } from '@app/services/stores/PaymentEditStore';
import { UserStore } from '@app/services/stores/UserStore';
import { take } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { AppDate } from '@app/util/app-date';
import { DATE_PICKER_CONFIG } from "@app/components/material/matDatePicker/mat-date-picker.component";
import { MatDialog } from "@angular/material/dialog";
import { AppDataService } from "@app/services/appData.service";
import { PaymentDateService, PaymentDateValidation } from '@app/services/PaymentDate.service';
import { moneyAdd } from "@app/util/money-number";
import { ActivatedRoute, Router } from "@angular/router";
import { PaymentTimingType } from '@app/services/shared/PaymentTimingType.enum';

@Component({
    selector: 'app-payment-edit',
    template: require('./paymentEdit.component.html')
})
export class PaymentEditComponent implements OnInit{

    nickname: string = 'Monthly Dues for Prop1';

    futurePayment: FuturePayment;
    futurePaymentIndex: number;
    futurePaymentId: number;
    existingFuturePayment: FuturePayment;

    dues: PaymentDue[];
    selectedDues: PaymentDue[] = [];
    amountToPay: number = 0;
    amountToPayErrorMsg: string;
    amountWasValid: boolean = false;

    paymentMethods: PaymentMethod[];
    currentPaymentMethod: PaymentMethod;
    calculatingConvenienceFee: boolean = true;
    convenienceFee: number;
    totalAmount: number;
    property: Property;
    ACHMessage: string;

    paymentDate: AppDate;
    datePickerConfig: DATE_PICKER_CONFIG = null;

    propertyId: number;

    paymentMethodError: boolean;
    paymentMethodErrorMsg: string;
    remainingPaymentsCheckbox: boolean = false;
    tcCheckbox: boolean = false;

    paymentScheduleId: number;
    paymentSchedule: PaymentSchedule;
    paymentScheduleType: string;
    accountBalanceTbd: boolean = true;

    maxPrincipalAmount: number;
    $stateParams: any;
    doneLoading: boolean = false;

    constructor(@Inject(MatDialog) private dialog: MatDialog,
                @Inject(PaymentScheduleApi) private paymentScheduleApi: PaymentScheduleApi,
                @Inject(SpinnerService) private spinnerService: SpinnerService,
                @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
                @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
                @Inject(PaymentApi) private paymentApi: PaymentApi,
                @Inject(PaymentMethodApi) private paymentMethodApi: PaymentMethodApi,
                @Inject(PaymentEditStore) private paymentEditStore: PaymentEditStore,
                @Inject(PropertyApi) private propertyApi: PropertyApi,
                @Inject(PaymentDateService) private pmtDateService: PaymentDateService,
                @Inject(UserStore) private userStore: UserStore,
                @Inject(AppDataService) private appDateService: AppDataService,
                @Inject(Router) private router: Router,
                @Inject(ActivatedRoute) private route: ActivatedRoute,
    ) {

        if (this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state;
        }

    }

    ngOnInit() {

        if (this.route.snapshot.params.paymentId && this.route.snapshot.params.scheduleId) {
            this.futurePaymentId = parseInt(this.route.snapshot.params.paymentId);
            this.paymentScheduleId = this.route.snapshot.params.scheduleId;

            if (this.$stateParams.paymentMethod) {
                this.currentPaymentMethod = this.$stateParams.paymentMethod;
            } else if (this.paymentEditStore.getPaymentMethod()) {
                this.currentPaymentMethod = this.paymentEditStore.getPaymentMethod();
            }
            this.updatePaymentMethod();
        }

        this.updateFuturePayment().then(() => {
            this.paymentDate = null
            const futurePayment = this.existingFuturePayment

            if (futurePayment && futurePayment.date) {
                const paymentAppDate = AppDate.fromString(futurePayment.date.formattedFullDate, "MM/dd/yyyy")

                this.setPaymentDate(paymentAppDate)
            }

            this.updateDues();
            this.updatePaymentMethods();
            this.setDefaultDate();
            this.updateProperty().then(() => {
                this.updateConvenienceFee();
                this.doneLoading = true;
            });
        });

        this.maxPrincipalAmount= this.appDateService.appSettings.paymentLimits.maxPrincipalAmount;
        this.ACHMessage = "Please note: you are making a payment through First Citizens Bank’s proprietary ACH payment system.";
    }

    /** returns once everything is refreshed */
    setDefaultDate(): void {
        const paymentAppDate =
            AppDate.fromString(this.futurePayment.date.formattedFullDate, "MM/dd/yyyy") || AppDate.now()

        // @ts-ignore
        const nextPaymentDateCall = this.pmtDateService.getNextValidPmtDate(paymentAppDate, true)
            .then((nextValidDate) => {
                this.paymentDate = nextValidDate;
            });

        // @ts-ignore
        nextPaymentDateCall.finally(() => {
            this.refreshDatePickers()
        });
    }

    async refreshDatePickers() {
        this.pmtDateService.getNextValidPmtDate(this.paymentDate, true).then((nextValidDate) => {
            this.paymentDate = nextValidDate;
        })

        this.updatePaymentDatePicker();

    }

    updatePaymentDatePicker() {
        let dateNewYorkTZ= new Date(new Date().toLocaleString('en-us', { timeZone: AppDate.timezone }));
        let minDate= AppDate.fromDate(dateNewYorkTZ);
        let pmtSchedStartDate = AppDate.fromString(this.paymentSchedule.startDate.formattedFullDate, "MM/dd/yyyy");

        if (pmtSchedStartDate.isAfter(minDate)) {
            minDate = pmtSchedStartDate;
        } else {
            let convertedBrowserDateString = new Date().toLocaleString("en-US", { timeZone: AppDate.timezone });
            let convertedBrowserDate = new Date(convertedBrowserDateString);
            let isPastCutoffHourSchedule =
                convertedBrowserDate.getHours() > this.appDateService.appConfig.CUTOFF_HOUR_SCHEDULE;
            let isPastCutoffMinuteSchedule = convertedBrowserDate.getMinutes() >=
                this.appDateService.appConfig.CUTOFF_MINUTE_SCHEDULE;

            if (isPastCutoffHourSchedule && isPastCutoffMinuteSchedule) {
                minDate = minDate.addDays(1);
            }
        }

        const isDateEnabled = date =>
            this.pmtDateService.validatePaymentDate(date,
                this.appDateService.appConfig.CUTOFF_HOUR_SCHEDULE,
                this.appDateService.appConfig.CUTOFF_MINUTE_SCHEDULE) === PaymentDateValidation.OK

        this.datePickerConfig = {
            defaultDate: AppDate.fromString(this.futurePayment.date.formattedFullDate, "MM/dd/yyyy") || AppDate.now(),
            isDateEnabled: isDateEnabled,
            minDate: minDate,
            validateDate: date => {
                if (date) {
                    this.setPaymentDate(date)
                }
            },
            preloadYear: year => this.pmtDateService.updateHolidays([year]),
        }
    }

    updateDues() {
        this.dues = this.selectedDues = [];
        if (this.existingFuturePayment && this.existingFuturePayment.items) {
            for (let due of this.existingFuturePayment.items) {
                if (due.description === "dues") {
                    this.dues.push({
                        name: due.description,
                        dueDate: this.existingFuturePayment.date,
                        amount: due.amount,
                        id: due.id,
                        toPay: true,
                        version: due.version
                    });
                    this.amountToPay = moneyAdd(this.amountToPay, (Number(due.amount) || 0));
                }
            }
        }

        if (!this.dues || this.dues.length === 0) {
            const zero: PaymentDue = {
                name: "",
                dueDate: { formattedFullDate: "", day: null, month: null, year: null },
                amount: "0.00",
                id: "",
                toPay: true
            }
            this.dues = this.selectedDues = [
                zero
            ];
        }

        this.totalAmount = (this.futurePayment && this.futurePayment.total) ? this.futurePayment.total : 0;
        this.convenienceFee = moneyAdd(this.totalAmount, -this.amountToPay);
    }

    updateProperty(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.calculatingConvenienceFee = true;
            this.propertyApi.propertiesIdGet(this.propertyId)
                .pipe().subscribe((resp) => {
                    this.property = resp;
                    this.paymentEditStore.setProperty(this.property);
                    this.calculatingConvenienceFee = false;
                    resolve();
                }, () => {
                    this.calculatingConvenienceFee = false;
                    reject();
                });
        })
    }

    updateFuturePayment(): Promise<void> {

        //could be improved by getting only the futurePayment by id instead of the entire payment schedule
        this.spinnerService.showSpinner();
        this.calculatingConvenienceFee = true;

        return new Promise<void>((resolve, reject) => {

            this.paymentScheduleApi.paymentSchedulesIdGet(this.paymentScheduleId)
                .pipe(take(1)).subscribe({ next: (resp) => {
                    this.calculatingConvenienceFee = false;
                    this.spinnerService.closeSpinner();
                    this.paymentSchedule = resp;
                    this.paymentSchedule.futurePayments.sort(
                        (a, b) =>
                            +new Date(a.date.formattedFullDate) - +new Date(b.date.formattedFullDate));
                    this.paymentScheduleType = resp.type;

                    this.currentPaymentMethod = resp.paymentMethod;
                    this.paymentEditStore.setPaymentMethod(this.currentPaymentMethod);
                    this.propertyId = resp.propertyId;
                    this.paymentEditStore.setPropertyId(this.propertyId);

                    if (this.paymentSchedule.futurePayments) {
                        for (let i = 0; i < this.paymentSchedule.futurePayments.length; i++) {
                            if (this.paymentSchedule.futurePayments[i].id === this.futurePaymentId) {
                                this.futurePaymentIndex = i
                                this.futurePayment = this.paymentSchedule.futurePayments[i];
                                break;
                            }
                        }
                    }
                    //these two lines are the only part that are needed to be kept
                    this.existingFuturePayment = Object.assign({}, this.futurePayment);

                    if (this.futurePayment.total !== undefined) {
                        this.accountBalanceTbd = false;
                    }
                    resolve()
                }, error: (error) => {
                    console.error("PaymentScheduleApi.paymentSchedulesIdGet Error")
                    console.error(error)
                    reject();
                } })

        })
    }

    save() {
        this.spinnerService.showSpinner();
        this.futurePayment.date = this.pmtDateService.dateObjectFromAppDate(this.paymentDate);
        this.futurePayment.total = this.totalAmount;
        this.futurePayment.items = [];
        this.futurePayment.paymentScheduleType = this.paymentScheduleType;
        let hasExistingConvenienceFee = false;

        // set or update the dues and/or convenience fee
        if (this.convenienceFee != null) {
            for (let item of this.existingFuturePayment.items) {
                if (item.description === "fee") {
                    hasExistingConvenienceFee = true;
                    this.futurePayment.items.push({
                        id: item.id,
                        description: item.description,
                        amount: this.convenienceFee,
                        version: item.version
                    });
                }
            }

            if (!hasExistingConvenienceFee) {
                this.futurePayment.items.push({
                    description: "fee",
                    amount: this.convenienceFee,
                });
            }
        }

        if (this.dues != null) {
            for (let due of this.dues) {
                this.futurePayment.items.push({
                    id: due.id,
                    description: /fee/i.test(due.name) ? 'fee' : 'dues',
                    amount: Number(due.amount),
                    version: due.version
                });
            }
        } else {
            this.futurePayment.items = [];
        }

        try {
            delete this.futurePayment.date.paymentDateErrorMsg;
        } catch (_deleteError) {
            // if it doesn't exist then we obviously don't need to remove it.
        }

        // different flow/API call when the remainingPaymentsCheckbox is checked
        if (this.remainingPaymentsCheckbox && this.paymentScheduleType !== 'account-balance') {
            for (let i = this.futurePaymentIndex; i < this.paymentSchedule.futurePayments.length; i++) {
                this.paymentSchedule.futurePayments[i].total = this.futurePayment.total
                for (let j = 0; j < this.paymentSchedule.futurePayments[i].items.length; j++) {

                    if (this.paymentSchedule.futurePayments[i].items[j].description === "dues") {
                        this.paymentSchedule.futurePayments[i].items[j].amount = this.amountToPay
                    } else if (this.paymentSchedule.futurePayments[i].items[j].description === "fee") {
                        this.paymentSchedule.futurePayments[i].items[j].amount = this.convenienceFee
                    }

                }
            }

            this.paymentSchedule.endDate = (this.paymentSchedule.remainingPayments &&
                                            this.paymentSchedule.endDate) ?
                this.paymentSchedule.endDate :
                null
            this.paymentSchedule.remainingPayments = (this.paymentSchedule.remainingPayments && this.paymentSchedule.endDate) ?
                this.paymentSchedule.remainingPayments :
                null
            this.paymentSchedule.principalAmount = this.amountToPay;
            this.paymentSchedule.feeAmount = this.convenienceFee;
            this.paymentSchedule.totalAmount = this.totalAmount;

            this.paymentScheduleApi.paymentSchedulesUpdatePost(this.paymentSchedule)
                .pipe(take(1)).subscribe({ next: () => {
                    this.router.navigateByUrl('/properties/scheduleView/' + this.paymentScheduleId, {
                        state: { scheduleId: this.paymentScheduleId }
                    });
                }, error: (err) => {
                    let errMsg: string = undefined;
                    if (err.error && err.error.message) {
                        errMsg = err.error.message;
                    }
                    this.errorHandlerService.handleNetworkError(err, true, errMsg)
                        .pipe(take(1)).subscribe(() => {}, () => {});
                } })

        } else {

            // if account balance TBD - reset total and items to null
            if (this.accountBalanceTbd) {
                this.futurePayment.total = null;
                this.futurePayment.items = [];
            }

            this.paymentScheduleApi.futurePaymentsPost(this.futurePayment)
                .pipe(take(1)).subscribe({ next: () => {
                    this.spinnerService.closeSpinner();
                    this.router.navigateByUrl('/properties/scheduleView/' + this.paymentScheduleId,
                        { state: { scheduleId: this.paymentScheduleId } } )
                }, error: (err) => {
                    let errMsg: string = undefined;
                    if (err.error && err.error.message) {
                        errMsg = err.error.message;
                    }
                    this.errorHandlerService.handleNetworkError(err, true, errMsg)
                        .pipe(take(1)).subscribe(() => {}, () => {});
                } })
        }
    }

    updatePaymentMethods() {
        let userId = this.userStore.getHoaHomeownerId();
        this.spinnerService.showSpinner();
        this.paymentMethodApi.homeownersIdPaymentMethodsGet(userId)
            .pipe(take(1)).subscribe((resp) => {
                this.spinnerService.closeSpinner();
                this.paymentMethods = resp;
                this.setSelectedPaymentMethod();
                if (this.paymentMethods && this.paymentMethods.length === 0) {
                    if (this.currentPaymentMethod) {
                        this.paymentMethods.push(this.currentPaymentMethod);
                    } else {
                        this.paymentMethodErrorMsg = "Please add a payment method.";
                        this.paymentMethodError = true;
                    }
                } else {
                    this.paymentMethodErrorMsg = null;
                    this.paymentMethodError = false;
                }
            }, (err) => {
                this.networkErrorService.handleNetworkError(err, true)
                    .pipe(take(1)).subscribe((resp) => {
                        if (resp === true) {
                            this.updatePaymentMethods();
                        }
                    });
            });
    }

    /** Use this instead of setting directly */
    setPaymentDate(date: AppDate) {
        this.paymentDate = date;
        this.futurePayment.date = this.pmtDateService.dateObjectFromAppDate(date);
        if (this.datePickerConfig) {
            this.datePickerConfig.defaultDate = this.paymentDate
        }
    }

    setSelectedPaymentMethod() {
        for (let paymentMethod of this.paymentMethods) {
            if (paymentMethod && paymentMethod.id) {
                if (paymentMethod.id === this.currentPaymentMethod.id) {
                    this.currentPaymentMethod = paymentMethod;
                    this.updatePaymentMethod();
                    break;
                }
            }
        }
    }

    updatePaymentMethod() {
        this.paymentEditStore.setPaymentMethod(this.currentPaymentMethod);
    }

    clearDue(due) {
        due.amount = 0.00;
        // When multiple line items get reinstated, we'll want to reevaluate this.
        // due.toPay = false;
        this.updateAmount();
    }

    clearAmountFieldWhen0(due) {
        if (due.amount <= 0) {
            due.amount = null;
            this.updateAmount();
        }
    }

    updateAmount() {
        this.selectedDues = [];
        this.amountToPay = 0;
        for (let due of this.dues) {
            if (due.id === "")
                due.toPay = true;
            if (due.toPay && due.toPay === true) {
                this.amountToPay = moneyAdd(this.amountToPay, (Number(due.amount) || 0));
                this.selectedDues.push(due);
            }
        }

        this.amountToPayError(+this.amountToPay);
        if ((this.amountToPay) > 0)
            this.amountWasValid = true;

        todo("Validate that we should be setting amount to pay like this, without dues...")
        this.paymentEditStore.setAmountToPay(this.amountToPay || null);

        this.updateConvenienceFee();
    }

    cancel() {
        this.router.navigateByUrl('/properties/scheduleView/' + this.paymentScheduleId,
            { state: { scheduleId: this.paymentScheduleId } })
    }

    amountToPayError(amtToPay) {
        if (this.maxPrincipalAmount && amtToPay > this.maxPrincipalAmount) {
            this.amountToPayErrorMsg = 'Payment amount cannot exceed $' + this.maxPrincipalAmount;
        } else {
            this.amountToPayErrorMsg = undefined;
        }
    }

    updateConvenienceFee() {
        if (!this.currentPaymentMethod) {
            this.currentPaymentMethod = this.paymentEditStore.getPaymentMethod();
        }
        let paymentMethodType: "ACH" | "CARD";
        if (this.currentPaymentMethod) {
            if (this.currentPaymentMethod.routingNumber !== null && this.currentPaymentMethod.routingNumber !== undefined)
                paymentMethodType = "ACH";
            else
                paymentMethodType = "CARD";
        }

        if (this.property && this.currentPaymentMethod && +this.amountToPay > 0) {
            this.calculatingConvenienceFee = true;
            // ACH Payment methods do not currently set their paymentMethod.state
            todo("Set the billing state of the payment method when the user registers the new payment method")
            const billingState = this.currentPaymentMethod.state || this.property.address.state

            this.paymentApi.convenienceFeePropertyIdAmountGet(false, this.property.address.state, billingState,
                this.amountToPay, this.property.hoa.pmc.couponId, this.property.hoa.couponId, paymentMethodType, PaymentTimingType.SCHEDULED, this.paymentSchedule.frequency)
                .pipe(take(1)).subscribe({ next:(data) => {
                    this.calculatingConvenienceFee = false;
                    this.convenienceFee = data.convenienceFee;
                    this.totalAmount = moneyAdd(this.amountToPay, this.convenienceFee);
                }, error: () => {
                    this.calculatingConvenienceFee = false;
                } });
        } else {
            this.convenienceFee = 0;
            this.totalAmount = 0;
        }
    }

    submitDisabled() {
        let zeroAmountDetected = false;
        // if account balance is TBD - we can let them save without having any amount
        if (!this.accountBalanceTbd) {
            for (let due of this.selectedDues) {
                if (Number(due.amount) === 0) {
                    zeroAmountDetected = true;
                } else if (due.amount === null || due.amount === undefined) {
                    zeroAmountDetected = true;
                }
            }
        }

        return (zeroAmountDetected
            || this.selectedDues.length === 0
            || this.amountToPayErrorMsg
            || this.calculatingConvenienceFee
            || (this.paymentDate == null)
            || (this.paymentMethods && this.paymentMethods.length === 0)
            || !(this.currentPaymentMethod)
            || !this.tcCheckbox
        );
    }

    datePickerDisabled() {
        return this.paymentScheduleType === 'account-balance'
    }

    checkTerms() {
        if (this.totalAmount === this.existingFuturePayment.total || this.tcCheckbox) {
            this.save();
        }
        //error state if the above doesn't happen
    }

    isDueAmountInvalid(due) {
        if (due.amount === undefined || due.amount === null) {
            return true;
        }
        return ((due.toPay && (!due.amount || Number(due.amount) <= 0) ||
            this.amountToPayErrorMsg || isNaN(due.amount)) && this.amountWasValid);
    }

    removeAccountBalanceTbd() {
        this.accountBalanceTbd = false;
    }

    onDateChange(value: unknown) {
        if(value instanceof AppDate) {
            this.setPaymentDate(value);
        }
    }
}
